export default {
  props: {
    extension: {
      type: Object,
      required: true
    }
  }
}
